import type { List } from '@gonfalon/immutable-shim/immutableShim';

import { getFallthroughRollout } from '#actions/pendingChanges';
import type { Clause as ImmutableClause } from '#utils/clause/records/Clause';
import { createClause } from '#utils/clause/records/Clause';
import type { Rollout } from '#utils/flags/records/Rollout';
import { createRollout } from '#utils/flags/records/Rollout';
import type { Rule as RuleRecord } from '#utils/flags/records/Rule';
import type { Variation } from '#utils/flags/records/Variation';

import { createAggregateRule } from './createAggregateRule';
import type { AggregateRule } from './types';

export const convertRuleToAggregateRule = (rule: RuleRecord, variations: List<Variation>): AggregateRule => {
  const clauses = rule.clauses.map((clause: ImmutableClause) => createClause(clause));
  const aggregateRule = createAggregateRule({ ...rule.toJS(), ruleId: rule._id, clauses: clauses.toJS() });
  if (rule.rollout) {
    const rolloutBucketBy = rule.rollout?.bucketBy;
    const rolloutWeights = getFallthroughRollout(createRollout(rule.rollout), variations).weights;
    const experimentAllocation = (rule.rollout as unknown as Rollout).experimentAllocation;
    const rolloutContextKind = rule.rollout?.contextKind;
    return {
      ...aggregateRule,
      rolloutBucketBy,
      rolloutContextKind,
      rolloutWeights,
      experimentAllocation,
    };
  }

  if (rule.variation !== undefined) {
    //rule.variation is an index of the list of variations
    return {
      ...aggregateRule,
      variationId: variations.get(rule.variation)?._id,
    };
  }
  return aggregateRule;
};
